import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyCode',
  standalone: true,
})
export class CurrencyCodePipe implements PipeTransform {
  transform(
    code: string | undefined,
    format: 'wide' | 'narrow' = 'narrow'
  ): unknown {
    if (!code) {
      return;
    }

    return getCurrencySymbol(code, format);
  }
}
